import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import { TWhatsappAccount, TWhatsappStatus } from '../entities/whatsapp.model';

@Injectable({
  providedIn: 'root',
})
export class WhatsappService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl;

  public startConnection(sessionId: string): Observable<TWhatsappStatus> {
    return this.http.get<TWhatsappStatus>(
      `${this.apiUrl.whatsapp_service}/Session/StartSession?accountId=${sessionId}`,
      {
        withCredentials: true,
      }
    );
  }

  public disconnect(sessionId: string): Observable<any> {
    return this.http.get(
      `${this.apiUrl.whatsapp_service}/Session/Disconnect?accountId=${sessionId}`,
      {
        withCredentials: true,
      }
    );
  }

  public getQrCode(sessionId: string): Observable<any> {
    return this.http.get(
      `${this.apiUrl.whatsapp_service}/Session/GetQrCode?accountId=${sessionId}`,
      {
        withCredentials: true,
      }
    );
  }

  public getStatus(sessionId: string): Observable<TWhatsappStatus> {
    return this.http.get<TWhatsappStatus>(
      `${this.apiUrl.whatsapp_service}/Session/Status?accountId=${sessionId}`,
      {
        withCredentials: true,
      }
    );
  }

  public saveCellphoneNumber(PhoneNumber: string): Observable<TWhatsappAccount> {
    return this.http.post<TWhatsappAccount>(
      `${this.apiUrl.whatsapp_service}/WhatsAppAccount`,
      { PhoneNumber },
      {
        withCredentials: true,
      }
    );
  }

  public remove(id: string): Observable<any> {
    return this.http.delete(
      `${this.apiUrl.whatsapp_service}/WhatsAppAccount?id=${id}`,
      {
        withCredentials: true,
      }
    );
  }

  public getWhatsappAccount(): Observable<TWhatsappAccount> {
    return this.http.get<TWhatsappAccount>(
      `${this.apiUrl.whatsapp_service}/WhatsAppAccount/GetByTenantIdAsync`,
      {
        withCredentials: true,
      }
    );
  }
}
